import React from "react";
import styles from "./LayoutStyles.module.scss";
import classNames from "classnames/bind";
import styled from "styled-components";
import { space } from "styled-system";

const cx = classNames.bind(styles);

const StyledRow = styled.div`
  margin: 0 -${(props) => props.gutter}px;
  &.radioCenter {
    background-color: #fff;
    display: flex;
    width: 100%;
    height: 50px;
    background-color: rgb(255, 255, 255);
    color: rgb(30, 30, 30);
    font-size: 16px;
    border-style: solid;
    border-width: 1px;
    border-color: rgba(73, 72, 120, 0.2);
    border-radius: 100px;
    transition: all 0.6s ease 0s;
    overflow: hidden;
    margin-left: 0;
    margin-right: 0;
    > div:nth-child(1) {
      > div {
        border-right: 1px solid rgba(73, 72, 120, 0.2);
        padding-left: 30px;
      }
    }
    > div {
      display: block;
      box-sizing: border-box;
      width: 50%;
      flex: 0 0 50%;
      height: 100%;
      display: flex;
      > div {
        height: 100%;
        display: flex;
        align-items: center;
        flex: 1 1 auto;
        padding-left: 20px;
      }
    }
    .homeRadio {
      display: flex;
      width: 100%;
      align-items: center;
      height: 100%;
      &.RadioBoxLabel .RadioBoxSymbol {
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  ${space}
`;

const StyledPadding = styled.div`
  padding: 0 ${(props) => props.padding}px;
`;

const StyledCol = styled.div`
  ${(props) => {
    const { span = 24 } = props;
    const width = (span / 24) * 100;
    return `flex: 0 0 ${width}%`;
  }}
`;

const Row = (props) => {
  const { gutter = 0, children, pb = 0, ...restProps } = props;
  const generateChildren = () => {
    if (Array.isArray(children)) {
      return children.map((child, idx) =>
        React.cloneElement(child, { key: idx, padding: gutter, ...child.props })
      );
    } else {
      return React.cloneElement(children, {
        padding: gutter,
        ...children.props,
      });
    }
  };
  return (
    <StyledRow className={cx("Row")} gutter={gutter} pb={pb} {...restProps}>
      {generateChildren()}
    </StyledRow>
  );
};

const Col = (props) => {
  const { children, padding, span, ...restProps } = props;

  const classnames = cx("Col", {
    [`Col_${span}`]: span,
    [`Col_ss_${props.ss}`]: props.ss,
    [`Col_xs_${props.xs}`]: props.xs,
    [`Col_sm_${props.sm}`]: props.sm,
    [`Col_md_${props.md}`]: props.md,
    [`Col_lg_${props.lg}`]: props.lg,
    [`Col_xl_${props.xl}`]: props.xl,
    [`Col_xxl_${props.xxl}`]: props.xxl,
  });
  return (
    <StyledCol className={classnames} {...restProps}>
      <StyledPadding padding={padding}>{children}</StyledPadding>
    </StyledCol>
  );
};

export { Row, Col };
